const throwIfMissing = (p: string): never => {
  throw new Error(`Missing parameter: ${p}`);
};

export default throwIfMissing;
